// Mapped to the DB

export const ChallengeType = {
    SINGLE_HABIT: 1,
    HABIT_GROUP: 2,
    WELLBEING_CATEGORY: 3
};

Object.freeze(ChallengeType);